import { BlogContainer, MainContent, RelatedPosts, Title, Date, Content, Image, RelatedPostItem, RelatedImage, RelatedCaption, Tags, BlogPostContainer } from "../styles/BlogPost.style";
import { FaTags } from "react-icons/fa6";
import EuphaWorldHeader from "../components/EuphaWorldHeader/EuphaWorldHeader";
const mockRelatedPosts = [
    {
      title: "How to Improve Your Writing Skills",
      image: "https://via.placeholder.com/60",
    },
    {
      title: "10 Tips for Better Productivity",
      image: "https://via.placeholder.com/60",
    },
    {
      title: "The Benefits of Morning Routines",
      image: "https://via.placeholder.com/60",
    },
  ];
  
const title = "The Power of Daily Habits"
const date = "June 1, 2021"
const image = "https://via.placeholder.com/800x400"
const content= "Developing strong daily habits can significantly improve productivity, health, and overall well-being. Learn how to establish routines that work for you."

const BlogPost = () => {
    return (
        <BlogPostContainer>
            <EuphaWorldHeader />
        <BlogContainer>
        <MainContent>
          <Title>{title}</Title>
          <Date>{date}</Date>
          <Image src={image} alt="Blog post" />
          <Content>{content}</Content>
          <Tags><FaTags /> Tag 1, Tag2, Tag3</Tags>
        </MainContent>
        <RelatedPosts>
          <h3>Related Posts</h3>
          {mockRelatedPosts.map((post, index) => (
            <RelatedPostItem key={index}>
              <RelatedImage src={post.image} alt={post.title} />
              <RelatedCaption>{post.title}</RelatedCaption>
            </RelatedPostItem>
          ))}
        </RelatedPosts>
      </BlogContainer>
      </BlogPostContainer>
    );
}

export default BlogPost;